import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { MessageSquare, Camera, TestTube, CheckCircle } from 'lucide-react';
import MessageTest from '../components/testing/MessageTest';
import PhotoTest from '../components/testing/PhotoTest';

const TestFeatures = () => {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    document.title = 'Pruebas de Funcionalidad - FemSportNet';
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <div className="p-3 bg-green-100 dark:bg-green-900 rounded-full">
                <TestTube className="h-8 w-8 text-green-600 dark:text-green-400" />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Verificación de Funcionalidades
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300">
              Prueba las funcionalidades principales de mensajería y subida de fotos
            </p>
          </div>

          {/* User Status */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-8">
            <div className="flex items-center">
              <CheckCircle className="h-6 w-6 text-green-500 mr-3" />
              <div>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Usuario Autenticado
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                  Conectado como: <span className="font-medium">{user?.name}</span> ({user?.email})
                </p>
              </div>
            </div>
          </div>

          {/* Test Sections */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Message Test */}
            <div>
              <div className="flex items-center mb-4">
                <MessageSquare className="h-6 w-6 text-blue-500 mr-2" />
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Prueba de Mensajería
                </h2>
              </div>
              <MessageTest />
            </div>

            {/* Photo Test */}
            <div>
              <div className="flex items-center mb-4">
                <Camera className="h-6 w-6 text-purple-500 mr-2" />
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                  Prueba de Subida de Fotos
                </h2>
              </div>
              <PhotoTest />
            </div>
          </div>

          {/* Feature Status */}
          <div className="mt-8 bg-white dark:bg-gray-800 rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Estado de las Funcionalidades
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center">
                  <MessageSquare className="h-5 w-5 text-blue-500 mr-2" />
                  <span className="text-gray-900 dark:text-white">Sistema de Mensajería</span>
                </div>
                <span className="text-green-500 font-medium">✓ Activo</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center">
                  <Camera className="h-5 w-5 text-purple-500 mr-2" />
                  <span className="text-gray-900 dark:text-white">Subida de Fotos</span>
                </div>
                <span className="text-green-500 font-medium">✓ Activo</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center">
                  <Upload className="h-5 w-5 text-green-500 mr-2" />
                  <span className="text-gray-900 dark:text-white">Compresión de Imágenes</span>
                </div>
                <span className="text-green-500 font-medium">✓ Activo</span>
              </div>
              
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center">
                  <Shield className="h-5 w-5 text-yellow-500 mr-2" />
                  <span className="text-gray-900 dark:text-white">Validación de Archivos</span>
                </div>
                <span className="text-green-500 font-medium">✓ Activo</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="mt-8 text-center">
            <div className="space-x-4">
              <a
                href="/messages"
                className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
              >
                <MessageSquare size={16} className="mr-2" />
                Ir a Mensajes
              </a>
              <a
                href="/photos"
                className="inline-flex items-center px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
              >
                <Camera size={16} className="mr-2" />
                Ir a Fotos
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestFeatures;